/**
 * Stacked proportional split bar (design prototype `.split`) — thin rounded
 * bar whose segments share the row by weight. Used by the "where paid
 * subscribers come from" breakdown.
 */
export interface SplitSegment {
  value: number;
  color: string;
  label?: string;
}

export default function SplitBar({ segments }: { segments: SplitSegment[] }) {
  const shown = segments.filter((s) => s.value > 0);
  if (shown.length === 0) return null;
  return (
    <div className="mb-4 flex h-2 gap-0.5 overflow-hidden rounded-full" role="img" aria-label="Breakdown">
      {shown.map((s, i) => (
        <div
          key={`${s.label ?? i}`}
          title={s.label}
          style={{ flex: s.value, background: s.color }}
        />
      ))}
    </div>
  );
}
